import React, { Component } from "react";
import { apiService } from "services/api";
import AuthService from "services/auth.service";
import { Form, Button } from "react-bootstrap";
import { Formik, ErrorMessage, Field } from "formik";
import Select from "react-select";
import "./../../assets/styles/Customer.scss";
import "../../modules/global";
import * as yup from "yup";
import moment from "moment";
import { questionnaire } from "constants/questionnaire";

let currentUser = AuthService.getCurrentUser();
class SearchCustomer extends Component {
  constructor(props) {
    super(props);

    this.params = new URLSearchParams(window.location.search);

    this.base_registry = {
      id: "",
      state_id: "",
      caring_store_id: "",
    };

    this.base_update = {
      email: "",
      gender: "",
      name: "",
      phone_number: "",
      blood_glucose: "",
      blood_glucose_fasting: "",
      booked_date: "",
      age: "",
      date_done: "",
      answer_1: "",
      answer_2: "",
      answer_3: "",
    };

    this.state = {
      stores: [],
      states: [],
      search: {
        phone_number: this.params.get("phone_number") || "",
      },
      registry: this.base_registry,
      update: this.base_update,
      formErrors: [],
      info: {},
      maxDate: moment().format("YYYY-MM-DD"),
    };

    this.searchCustomer = this.searchCustomer.bind(this);
  }

  updateSchema = yup.object().shape(
    {
      name: yup.string().required().max(100).label("Name"),
      age: yup.object().required().label("Age"),
      email: yup.string().when("email", {
        is: (exists) => !!exists,
        then: yup.string().email().required().max(50).label("Email"),
        otherwise: yup.string().notRequired(),
      }),
      phone_number: yup
        .string()
        .required()
        .min(10, "Phone number is invalid")
        .max(15, "Phone number is invalid")
        .matches("^[0-9]*$", "Phone number is invalid")
        .label("Phone number"),
      gender: yup.object().required().label("Gender"),
      blood_glucose_fasting: yup
        .number()
        .min(0, "Invalid value: cannot be below 0")
        .max(30, "Invalid value: cannot be above 30"),
      blood_glucose: yup
        .number()
        .min(0, "Invalid value: cannot be below 0")
        .max(30, "Invalid value: cannot be above 30 "),
    },
    [["email", "email"]]
  );

  getStatesAndStores() {
    apiService.stores(currentUser?.type).then(
      (response) => {
        if (response) {
          this.setState({
            states: response.states,
            stores: response.stores,
          });
          if (this.params.get("phone_number")) {
            this.searchCustomer();
          }
        }
      },
      (error) => {
        this.setState({ error, loading: false });
      }
    );
  }

  componentDidMount() {
    this.getStatesAndStores();
  }

  handleUpdate(formData) {
    this.setState(
      (prevState) => {
        const caringStoreId = currentUser?.caring_stores[0]?.id;

        return {
          info: {
            ...prevState.info,
            name: formData.name,
            email: formData.email,
            phone_number: formData.phone_number,
            gender: formData.gender.value,
            age: formData.age.value,
            blood_glucose: formData.blood_glucose,
            blood_glucose_fasting: formData.blood_glucose_fasting,
            answer_1: formData?.answer_1?.value,
            answer_2: formData?.answer_2?.value,
            answer_3: Array.isArray(formData?.answer_3)
              ? formData.answer_3.map((o) => o.value).join(",")
              : formData?.answer_3?.value,
            booked_date: formData.booked_date,
            ...(caringStoreId && { caring_store_id: caringStoreId }),
          },
        };
      },
      () => {
        this.update();
      }
    );
  }

  update() {
    if (this.state.registry.id) {
      this.setState({
        formErrors: "",
      });
      apiService.update_info(this.state.registry.id, this.state.info).then(
        (response) => {
          if (response && response.hasOwnProperty("errors")) {
            this.setState({
              formErrors: response.errors,
            });
          } else {
            alert("Updated successfully");

            const gender = this.findOption(
              global.constant.genders,
              response.gender
            );
            const age = this.findOption(global.constant.ages, response.age);
            const answer_1 = this.getAnswer(
              questionnaire,
              response,
              "answer_1"
            );
            const answer_2 = this.getAnswer(
              questionnaire,
              response,
              "answer_2"
            );
            const answer_3 = this.getAnswer(
              questionnaire,
              response,
              "answer_3"
            );

            this.setState({
              update: {
                name: response.name,
                booked_date:
                  response.booked_date || moment().format("YYYY-MM-DD"),
                booked_datetime: response.booked_datetime
                  ? moment(response.booked_datetime).format("YYYY-MM-DDTHH:mm")
                  : moment().format("YYYY-MM-DDTHH:mm"),
                email: response.email,
                phone_number: response.phone_number,
                gender: gender,
                age: age,
                blood_glucose: response.blood_glucose,
                blood_glucose_fasting: response.blood_glucose_fasting,
                answer_1: answer_1,
                answer_2: answer_2,
                answer_3: answer_3,
                date_done: response.date_done,
                caring_store_id: response.caring_store_id,
              },
            });
          }
        },
        (error) => {
          this.setState({ error, loading: false });
        }
      );
    }
  }

  findOption(options, value) {
    return options.find((x) => x.value === value);
  }

  getAnswer(questionnaire, response, key) {
    const question = questionnaire.find((q) => q.name === key);
    const value = response?.[key];
    if (!value) return null;
    if (question?.isCheckbox) {
      return value
        .toString()
        .split(",")
        .map((v) => this.findOption(question?.options || [], Number(v.trim())))
        .filter(Boolean);
    }
    return this.findOption(question?.options || [], Number(value));
  }

  searchCustomer() {
    apiService.search_customer(this.state.search).then(
      (response) => {
        if (response) {
          const gender = this.findOption(
            global.constant.genders,
            response.gender
          );
          const age = this.findOption(global.constant.ages, response.age);
          const answer_1 = this.getAnswer(questionnaire, response, "answer_1");
          const answer_2 = this.getAnswer(questionnaire, response, "answer_2");
          const answer_3 = this.getAnswer(questionnaire, response, "answer_3");

          this.setState({
            registry: response,
            searchError: null,
            update: {
              name: response.name,
              booked_date:
                response.booked_date || moment().format("YYYY-MM-DD"),
              booked_datetime: response.booked_datetime
                ? moment(response.booked_datetime).format("YYYY-MM-DDTHH:mm")
                : moment().format("YYYY-MM-DDTHH:mm"),
              email: response.email,
              phone_number: response.phone_number,
              gender: gender,
              age: age,
              answer_1: answer_1,
              answer_2: answer_2,
              answer_3: answer_3,
              blood_glucose:
                response.blood_glucose === null ? "" : response.blood_glucose,
              blood_glucose_fasting:
                response.blood_glucose_fasting === null
                  ? ""
                  : response.blood_glucose_fasting,
              date_done: response.date_done,
            },
          });
        } else {
          this.setState({
            searchError: "Not Found",
            registry: this.base_registry,
            update: this.base_update,
          });
        }
      },
      (error) => {
        this.setState({ error, loading: false });
      }
    );
  }

  getGender(value) {
    let d = "";
    if (value) {
      let x = global.constant.genders.find((gender) => gender.value === value);
      if (x) {
        d = x.label;
      }
    }
    return d;
  }

  getStateName(value) {
    let d = "";
    if (value) {
      let x = this.state.states.find((state) => state.id === value);
      if (x) {
        d = x.name;
      }
    }
    return d;
  }

  getStoreName(value) {
    let d = "";
    if (value) {
      let x = this.state.stores.find((store) => store.id === value);
      if (x) {
        d = x.name;
      }
    }
    return d;
  }

  getBloodGlucosePost(value) {
    let x = "";
    let color = "";
    if (value > 11) {
      x = "Diabetic";
      color = "red";
    } else if (value < 7.7) {
      x = "Normal";
      color = "green";
    } else {
      x = "Prediabetic";
      color = "orange";
    }

    return <span className={color}>{x}</span>;
  }
  getBloodGlucoseFasting(value) {
    let x = "";
    let color = "";

    if (value > 7) {
      x = "Diabetic";
      color = "red";
    } else if (value < 6) {
      x = "Normal";
      color = "green";
    } else {
      x = "Prediabetic";
      color = "orange";
    }

    return <span className={color}>{x}</span>;
  }

  render() {
    const SelectField = (FieldProps) => (
      <Select
        className="select-field"
        isDisabled={FieldProps.disabled}
        options={FieldProps.options}
        {...FieldProps.field}
        onChange={(option) =>
          FieldProps.form.setFieldValue(FieldProps.field.name, option)
        }
      />
    );

    const MultiSelectField = (FieldProps) => (
      <Select
        className="select-field"
        isDisabled={FieldProps.disabled}
        placeholder="Choose your answer"
        options={FieldProps.options}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        {...FieldProps.field}
        onChange={(option) =>
          FieldProps.form.setFieldValue(FieldProps.field.name, option || [])
        }
      />
    );

    return (
      <div className="customer-page">
        <h4 style={{ fontWeight: "bold" }}>Search Customer</h4>

        <div className="content-container">
          <div className="search-row">
            <Form.Group className="my-3 d-flex">
              <Form.Control
                className="search-field"
                placeholder="Search by Phone No. (e.g. 60123456789)"
                name="phone_number"
                value={this.state.search.phone_number}
                onChange={(e) =>
                  this.setState({ search: { phone_number: e.target.value } })
                }
              />
              <Button
                className="search-btn"
                type="button"
                onClick={this.searchCustomer}
              >
                Search
              </Button>
            </Form.Group>
            {this.state.searchError && (
              <div className="search-error">{this.state.searchError}</div>
            )}
          </div>

          {this.state.update.name && (
            <Formik
              enableReinitialize
              validationSchema={this.updateSchema}
              onSubmit={(form, actions) => this.handleUpdate(form, actions)}
              initialValues={this.state.update}
            >
              {({ handleSubmit, handleChange, values }) => (
                <React.Fragment>
                  <div className="info-container">
                    <h4 style={{ fontWeight: "bold" }}>Customer Information</h4>
                    <div
                      className={
                        this.state.update.date_done
                          ? "disabled-form"
                          : currentUser.role !== "caring_store_admin"
                          ? "disabled-form"
                          : ""
                      }
                    >
                      <div className="d-flex justify-content-between field-row ">
                        <Form.Group className="mb-3 field-col">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            name="name"
                            type="text"
                            value={values.name}
                            maxLength="100"
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            component="div"
                            name="name"
                            className="invalid-feedback"
                          />
                        </Form.Group>

                        <Form.Group className="mb-3 field-col">
                          <Form.Label>Age</Form.Label>
                          <Field
                            name="age"
                            placeholder="Age*"
                            options={global.constant.ages}
                            value={values.age}
                            component={SelectField}
                          />
                          <ErrorMessage
                            component="div"
                            name="age"
                            className="invalid-feedback"
                          />
                        </Form.Group>
                      </div>

                      <div className="d-flex justify-content-between field-row">
                        <Form.Group className="mb-3 field-col">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            name="email"
                            type="email"
                            value={values.email}
                            maxLength="50"
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            component="div"
                            name="email"
                            className="invalid-feedback"
                          />
                        </Form.Group>

                        <Form.Group className="mb-3 field-col">
                          <Form.Label>Phone Number</Form.Label>
                          <Form.Control
                            name="phone_number"
                            type="text"
                            value={values.phone_number}
                            maxLength="20"
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            component="div"
                            name="phone_number"
                            className="invalid-feedback"
                          />
                        </Form.Group>
                      </div>

                      <div className="d-flex justify-content-between field-row">
                        <Form.Group className="mb-3 field-col field-row select-field">
                          <Form.Label>Gender</Form.Label>
                          <Field
                            name="gender"
                            options={global.constant.genders}
                            component={SelectField}
                          />
                          <ErrorMessage
                            component="div"
                            name="gender"
                            className="invalid-feedback"
                          />
                        </Form.Group>

                        <Form.Group className="mb-3 field-col">
                          <Form.Label>State</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.getStateName(
                              this.state.registry.state_id
                            )}
                            readOnly
                            disabled
                          />
                        </Form.Group>
                      </div>

                      <div className="d-flex justify-content-between field-row">
                        <Form.Group className="mb-3 field-col">
                          <Form.Label>Preferred Outlet</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.getStoreName(
                              values.caring_store_id ||
                                this.state.registry.caring_store_id
                            )}
                            readOnly
                            disabled
                          />
                        </Form.Group>
                        {currentUser.type === "mog" ? (
                          <Form.Group className="mb-3 field-col">
                            <Form.Label>Booked Datetime</Form.Label>
                            <Form.Control
                              name="booked_datetime"
                              type="datetime-local"
                              value={values.booked_datetime}
                              onChange={handleChange}
                              className="disabled-form"
                            />
                          </Form.Group>
                        ) : (
                          <>
                            <Form.Group className="mb-3 field-col">
                              <Form.Label>Booked Date</Form.Label>
                              <Form.Control
                                name="booked_date"
                                type="date"
                                value={values.booked_date}
                                onChange={handleChange}
                                className="disabled-form"
                              />
                            </Form.Group>
                          </>
                        )}
                      </div>

                      <div className="form-container mt-4">
                        <Form noValidate onSubmit={handleSubmit}>
                          {currentUser?.type === "healthlane" && (
                            <>
                              <div className="border border-danger p-4 rounded bg-opacity-10 mb-4">
                                <h2 className="h6 fw-bold text-danger mb-3">
                                  Blood Glucose Test
                                </h2>

                                <div className="d-flex flex-column flex-md-row gap-4 align-items-stretch">
                                  <Form.Group className="mb-3 flex-fill">
                                    <Form.Label>
                                      Blood Glucose (Fasting) (mmol/L)
                                    </Form.Label>
                                    <Form.Control
                                      type="number"
                                      max={30}
                                      name="blood_glucose_fasting"
                                      value={values.blood_glucose_fasting}
                                      onChange={handleChange}
                                    />
                                    {this.state.update
                                      .blood_glucose_fasting && (
                                      <>
                                        {this.getBloodGlucoseFasting(
                                          this.state.update
                                            .blood_glucose_fasting
                                        )}
                                      </>
                                    )}
                                    <ErrorMessage
                                      component="div"
                                      name="blood_glucose_fasting"
                                      className="invalid-feedback"
                                    />
                                  </Form.Group>

                                  <Form.Group className="mb-3 flex-fill">
                                    <Form.Label>
                                      Blood Glucose (2 Hour Post Prandial)
                                      (mmol/L)
                                    </Form.Label>
                                    <Form.Control
                                      type="number"
                                      max={30}
                                      name="blood_glucose"
                                      value={values.blood_glucose}
                                      onChange={handleChange}
                                    />
                                    {this.state.update.blood_glucose && (
                                      <>
                                        {this.getBloodGlucosePost(
                                          this.state.update.blood_glucose
                                        )}
                                      </>
                                    )}
                                    <ErrorMessage
                                      component="div"
                                      name="blood_glucose"
                                      className="invalid-feedback"
                                    />
                                  </Form.Group>
                                </div>
                              </div>

                              <div className="bg-light p-4 rounded border mb-4">
                                <h3 className="h6 fw-semibold text-dark mb-3">
                                  Lifestyle Questionnaire
                                  <span className="ms-2 text-muted small fst-italic">
                                    (Optional)
                                  </span>
                                </h3>

                                {questionnaire.map((question, index) => (
                                  <div className="mb-3" key={question.id}>
                                    <label className="form-label fw-medium">
                                      {index + 1}. {question.text}
                                    </label>
                                    <Field
                                      name={question.name}
                                      component={
                                        question.isCheckbox
                                          ? MultiSelectField
                                          : SelectField
                                      }
                                      placeholder="Choose your answer"
                                      options={question.options}
                                      disabled={values[question.name] !== null}
                                    />
                                    <ErrorMessage
                                      component="div"
                                      name={question.name}
                                      className="invalid-feedback"
                                    />
                                  </div>
                                ))}
                              </div>
                            </>
                          )}

                          {Object.keys(this.state.formErrors).length > 0 && (
                            <ul className="mt-3 text-danger small ps-3">
                              {Object.entries(this.state.formErrors).map(
                                ([key, value], i) => (
                                  <li key={i}>
                                    {key}: {value}
                                  </li>
                                )
                              )}
                            </ul>
                          )}

                          <div className="d-flex flex-column flex-md-row align-items-end justify-content-between gap-3">
                            <Form.Group className="w-100 w-md-50">
                              <Form.Label>Date Completed</Form.Label>
                              <Form.Control
                                name="date_done"
                                type="text"
                                value={
                                  values.date_done
                                    ? moment(values.date_done).format(
                                        "YYYY-MM-DD"
                                      )
                                    : ""
                                }
                                readOnly
                                disabled
                              />
                            </Form.Group>

                            <Button
                              variant="primary"
                              type="submit"
                              className="fw-semibold px-4 py-2"
                              disabled={
                                currentUser?.type === "mog"
                                  ? this.state.update.date_done
                                  : false
                              }
                            >
                              {currentUser?.type === "mog" ? "Done" : "Save"}
                            </Button>
                          </div>
                        </Form>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </Formik>
          )}
        </div>
      </div>
    );
  }
}

export { SearchCustomer };
